import {IntermediatePart} from "../../intermediatePart";

export default class TallCabinet extends IntermediatePart {
  constructor(isChild, partNumber = 0) {
    super(isChild);
    this.partNumber = partNumber;
    this.partId = 'tall_cabinet';
    this.partName = 'Tall Cabinet';
    this.translateId = "visualizer.kitchen.cabinet.tall_cabinet";
    this.canBeDisabled = false;
    this.hasAdditionalParts = true;
    this.layerPriority = 1;
    this.allWallsCanBeApplied = true;
  }
}

